import React from 'react';
import './occasion info.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon} from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Tooltip from '@material-ui/core/Tooltip';
import { Info } from '@material-ui/icons';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message,Image,Empty } from "antd";
import Pagination from '@material-ui/lab/Pagination';
import Skeleton from 'react-loading-skeleton';
import moment from "moment";
import { UploadOutlined } from '@ant-design/icons';

class occasionInfo extends React.Component {
    state = {
        actionType:this.props.location.state.actionType?this.props.location.state.actionType==="EDIT"?"EDIT":"VIEW":"VIEW",
        id:this.props.location.state.data.id,
        name:this.props.location.state.data.name?this.props.location.state.data.name:allStrings.notExist,
        city:this.props.location.state.data.city?this.props.location.state.data.city:allStrings.notExist,
        date:this.props.location.state.data.date?this.props.location.state.data.date:allStrings.notExist,
        time:this.props.location.state.data.time?this.props.location.state.data.time:allStrings.notExist,
        createdAt:this.props.location.state.data.createdAt?this.props.location.state.data.createdAt:allStrings.notExist,
        remainingDate:this.props.location.state.data.remainingDate?this.props.location.state.data.remainingDate:0,
        fullDate:this.props.location.state?this.props.location.state.data.fullDate?this.props.location.state.data.fullDate:null:null,
        img:this.props.location.state?this.props.location.state.data.img?this.props.location.state.data.img:null:null,
        repetition:this.props.location.state.data.repetition,
        type:this.props.location.state.data.type,
        end:this.props.location.state.data.end,
        owner:this.props.location.state.data.owner,
        description:this.props.location.state.data.description?this.props.location.state.data.description:allStrings.notExist,
        loading:true,
        imgName:'',
        imgType:'url',
        page:1,
        pages:1,
        page2:1,
        pages2:1,
        audiences:[]
       
    };

    constructor(props){
        super(props)
        window.scrollTo(0,0)
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    componentDidMount(){
        this.getAudiences()
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }
    fileChangedHandler = event => {
        
      this.setState({
        img: event.target.files[0],
        imgName: event.target.files[0].name,
        imgType:"data"
      })
     
      
    }
    removeFile = () => {
      this.setState({
          img:null,
          imgName:'',
          imgType:"url"
      });
    }
    getAudiences = () => {
        axios.get(`${BASE_END_POINT}occasions/${this.props.location.state.data.id}/getAudience`,
        {
            headers:{
              'Authorization':`Bearer ${this.props.currentUser.token}`,
              'Accept-Language':this.props.isRTL?'ar':'en'
            }
        })
        .then(response=>{
            this.setState({
              audiences:response.data.data,
              pages2:response.data.pageCount,
              page2:response.data.page,
              loading:false,
            })
        })
        .catch(error=>{
            console.log('getAudience ERROR  ',error)
            console.log('getAudience ERROR  ',error.respose)
        })
    }
    updateoccasion = () => {
        const {name,city,time,fullDate,description,
            date,type} = this.state
        let l = message.loading('Wait..', 2.5)
        if(type ==="PUBLIC" ){
            if(fullDate === ''){
                l.then(() => message.error(allStrings.completeData, 2.5) )
            }
        }
        if(hasValue(name)&&hasValue(description)){

            var data = {
                'name':name,
                'city':city,
                'description':description
            }
            if(date){
                data.date = date
            }
            
            if(fullDate){
                data.fullDate = fullDate
            }
            if(time){
                data.endDate = time
            }
            let url = `${BASE_END_POINT}occasions/${this.props.location.state.data.id}`

            console.log(data)
            axios.put(url,data,{
            headers: {
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${this.props.currentUser.token}`,
            'Accept-Language':this.props.isRTL?'ar':'en'
            },
            })
            .then(response=>{
            console.log("occasion UPDATED  ",response.data)
            l.then(() => message.success(allStrings.done, 2.5) )
            this.props.history.goBack() 
            })
            .catch(error=>{
                console.log(error.response)
                l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
            })
        }
    }

    deleteoccasion = () => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}occasions/${this.props.location.state.data.id}`,{
         headers: {
           'Content-Type': 'application/json',
           'Authorization':`Bearer ${this.props.currentUser.token}`,
           'Accept-Language':this.props.isRTL?'ar':'en'
         },
        })
        .then(response=>{
          console.log("occasion DELETED")
          l.then(() => message.success(allStrings.done, 2.5) )
          this.props.history.goBack() 
        })
        .catch(error=>{
            console.log(error.response)
            l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
        })
    }
   

    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.updateoccasion()
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    imageSection = () =>{
      return(
        <MDBCol  xl ="4" lg = "5"  md="12" sm="12">
          <div className="infoCard">
              <div style={{width:"100%" ,padding:'10px'}}>
                <Image
                  width="100%"
                  placeholder={true}
                  style={{borderRadius:'6px',width:"100%",height:'280px'}} 
                  src={this.state.imgType==="data"?URL.createObjectURL(this.state.img):this.props.location.state.data.img}
                />
              </div>
          </div>
        </MDBCol>
      )
    }
    audiencesTable = () =>{
        return(
        <MDBRow>
            <MDBCol md="12">
                <div className="infoTable">
                    <div className="topInfoTable" style={{ background: '#117183' }}>
                        <h4>
                        <MDBIcon icon="val" /> {allStrings.audiences}
                        </h4>
                    </div>
                    <div className="tableDate">
                        <div className="table-responsive">
                            <table className="table table-striped">
                            <thead>
                            {this.props.isRTL?
                                <tr style={{textAlign:'center'}}>
                                    <th>{allStrings.more}</th>
                                    <th>{allStrings.name}</th>
                                    <th>{allStrings.img}</th>
                                    <th scope="col">#</th>
                                </tr>
                                    :
                                <tr style={{textAlign:'center'}}>
                                    <th scope="col">#</th>
                                    <th>{allStrings.img}</th>
                                    <th>{allStrings.name}</th>
                                    <th>{allStrings.more}</th>
                                </tr>
                            }
                                
                            </thead>
                            <tbody>
                            {this.state.loading?
                                <tr style={{height: '200px'}}>
                                    <th colSpan="6" className="noData">
                                    <Skeleton height={400}/> 
                                    </th>
                                </tr>
                                :
                                this.state.audiences.length > 0 ?
                                this.state.audiences.map(val =>(
                                this.props.isRTL?
                                <tr style={{textAlign:'center'}}>
                                    <td onClick={()=>{this.props.history.push("userInfo",{data:val}) }} >
                                    <span style={{margin: "4px",cursor:'pointer'}}>
                                        <Tooltip title={allStrings.info} placement="top">
                                        <Info style={{color:'#33d633'}}/>
                                        </Tooltip>
                                    </span>
                                    </td>
                                    <td>{val.fullname}</td>
                                    <td><Image
                                        width="50px"
                                        height="50px"
                                        placeholder={true}
                                        style={{borderRadius:'50%',width:"50px",height:'50px',padding:'5px'}} 
                                        src={val.img?val.img:require('../../assets/images/profileicon.jpg')}
                                        /></td>
                                    <td>{val.id}</td>
                                </tr>
                                :
                                <tr style={{textAlign:'center'}}>
                                    <td>{val.id}</td>
                                    <td><Image
                                        width="50px"
                                        height="50px"
                                        placeholder={true}
                                        style={{borderRadius:'50%',width:"50px",height:'50px',padding:'5px'}} 
                                        src={val.img?val.img:require('../../assets/images/profileicon.jpg')}
                                        /></td>
                                    <td>{val.fullname}</td>
                                    <td onClick={()=>{this.props.history.push("userInfo",{data:val}) }} >
                                    <span style={{margin: "4px",cursor:'pointer'}}>
                                        <Tooltip title={allStrings.info} placement="top">
                                        <Info style={{color:'#33d633'}}/>
                                        </Tooltip>
                                    </span>
                                    </td>
                                </tr>
                                    ))
                
                                    :
                                    <tr style={{height: '200px'}}>
                                        <th colSpan="6" className="noData">
                                        <Empty description={allStrings.noData} style={{margin:'0rem'}}/>
                                        </th>
                                    </tr>
                                }
                            </tbody>
                            </table>
                            {this.state.audiences.length > 0 &&
                                <div style={{textAlign:'center',margin:'auto',marginTop:'3rem'}}>
                                    {this.paginationButtons2()}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </MDBCol>
        </MDBRow>
        )
    }
    paginationButtons2 = () =>(
        <CardActions style={{display: 'inline-flex'}}>
            <Button 
            onClick={()=>{
              if(this.state.page2!==1){
                this.getAudiences(1)
                this.setState({page2:1})
              }
            }}
            className="pagenation" >{allStrings.first}</Button>
    
            <Button 
            onClick={()=>{
              if(this.state.page2>1){
                this.getAudiences(this.state.page2-1)
                this.setState({page2:this.state.page2-1})
              }
            }}
            className="pagenation">{allStrings.prev}</Button>
            
            <Pagination
            onChange={(event,page2)=>{
            console.log("page   ",page2)
            if(page2!==this.state.page2){
              this.getAudiences(page2)
              this.setState({page2:page2})
            }
            
            }} 
            defaultPage={1} page={this.state.page2} count={this.state.page2} style={{color:`${'#117183'} !important`}} />
            
            <Button 
            onClick={()=>{
              if(this.state.page2<this.state.pages2){
                this.getAudiences(this.state.page2+1)
                this.setState({page2:this.state.page2+1})
              }
            }}
            className="pagenation">{allStrings.next}</Button>
    
            <Button 
              onClick={()=>{
              if(this.state.page2!==this.state.pages2){
                this.getAudiences(this.state.pages2)
                this.setState({page2:this.state.pages2})
              }
            }}
            className="pagenation">{allStrings.last}</Button>
    
        </CardActions>
    )
    
    
  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('OCCASIONS')) return <Redirect to='/Home' />

  return (
    <div className="App">
        <MDBContainer> 
            <MDBRow>  
                <MDBCol xl={this.state.actionType==="VIEW"?"8":"12"} lg = {this.state.actionType==="VIEW"?"7":"12"} md="12" sm="12">
                    <div className="infoCard">
                        <Card className="editCard" style={{overflow: 'visible',outline:'none',marginBottom:'0px'}}>
                            <CardMedia
                            style={{height:"0px"}}
                            />
                            <CardHeader></CardHeader>
                            <div style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                                <div className="topIcon" style={{background:'#117183'}}>
                                    <span className="material-icons" style={{color:'white',fontSize:23}}>event</span>
                                </div>
                                <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                                marginLeft:this.props.isRTL?'0':'0rem',marginRight:this.props.isRTL?'0rem':'0'}}>
                                <p>{this.state.actionType ==="VIEW"?allStrings.occasionInfo:allStrings.edit}</p>
                                </div>
                            </div>
                            <CardContent style={{minHeight:"390px",outline:'none'}}>
                                <MDBContainer>
                                    
                                    <MDBRow>
                                        <MDBCol md="12">
                                        <form
                                        className="needs-validation"
                                        onSubmit={this.submitHandler}
                                        noValidate
                                        >
                                            
                                            <div className="grey-text">
                                            {this.state.actionType ==="VIEW"&&
                                            <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form8" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>#</label>
                                                    <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.id} type="text" id="form8" className="form-control" validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form86" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.repetition}</label>
                                                    <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.repetition==="YEARLY"?allStrings.yearly:this.state.repetition==="MONTHLY"?allStrings.monthly:allStrings.daily} type="text" id="form86" className="form-control" validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            }
                                            <MDBRow>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                        <label htmlFor="form695" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.type}</label>
                                                        <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.type==="PRIVATE"?allStrings.private:allStrings.public} type="text" id="form695" name="type" className="form-control" onChange={this.changeHandler} required  validate/>
                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form806" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.end}</label>
                                                    <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.end?allStrings.yes:allStrings.no} type="text" id="form806" className="form-control" validate/>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.name}</label>
                                                    <input disabled={this.state.actionType==="VIEW"?true:false} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.name} type="text" id="form645" name="name" className="form-control" onChange={this.changeHandler} required  validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form56" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.city}</label>
                                                    <input disabled={this.state.actionType==="VIEW"?true:false}  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.city} type="text" id="form56" name="city" className="form-control" onChange={this.changeHandler} required validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                        
                                            <MDBRow>
                                            <MDBCol md="12">
                                                <div className="md-form">
                                                <label htmlFor="form920" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.description}</label>
                                                <br></br>
                                                <textarea disabled={this.state.actionType==="VIEW"?true:false} name="description" onChange={this.changeHandler} value={this.state.description} 
                                                style={{border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} 
                                                type="text" id="form920" className="form-control" required validate   />
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                            </MDBCol>
                                            
                                            </MDBRow>
                                            
                                            <MDBRow style={{flexFlow:this.props.isRTL?'row-reverse':'row'}}  >
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.occasionDate}</label>
                                                    <input disabled={this.state.actionType==="VIEW"?true:false} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={moment(this.state.date).format('YYYY-MM-DD')} type="text" id="form645" name="date" className="form-control" onChange={this.changeHandler} required  validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form56" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.occasionTime}</label>
                                                    <input disabled={this.state.actionType==="VIEW"?true:false} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.time} type="text" id="form56" name="time" className="form-control" onChange={this.changeHandler} required validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow style={{flexFlow:this.props.isRTL?'row-reverse':'row'}}  >
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.createdAt}</label>
                                                    <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={moment(this.state.createdAt).format('lll')} type="text" id="form645" name="createdAt" className="form-control" validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                    <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.remainingDate}</label>
                                                    <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.remainingDate > 0?this.state.remainingDate +" "+ allStrings.day: "0 " + allStrings.day} type="text" id="form645" name="remainingDate" className="form-control" validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            {this.state.actionType==="EDIT"&&
                                            <MDBRow>
                                                <MDBCol md="12">
                                                <label htmlFor="form8930" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.profileImg}</label>

                                                    <div className="fileUpload2"> 
                                                        <input  key={this.state.img} type='file' className="upImgs2" onChange={this.fileChangedHandler} ></input>
                                                        <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.upload}</span></span>
                                                    </div>
                                                    <div className="preview">
                                                    {this.state.img&&
                                                    <div style={{display:"inline-block",width: '100%',border: '1px solid mediumaquamarine'}}>
                                                        <img alt="" src={this.state.imgType==="data"?URL.createObjectURL(this.state.img):this.state.img} className="previewImg2"/>
                                                        
                                                        <span className="imgName">{this.state.imgName}</span>
                                                        <MDBIcon icon="trash" className="mr-2 removeImg3"
                                                        onClick={() => this.removeFile()}  ></MDBIcon>
                                                    </div>
                                                    }
                                                    </div>
                                                    
                                                </MDBCol>
                                            </MDBRow>
                                        }
                                            
                                        
                                            
                                            </div>
                                            <br></br>
                                            <br></br>
                                            <div className="text-center">
                                            {this.state.actionType==="EDIT"&&
                                                <MDBBtn
                                                style={{background:'#117183',color:'#fff'}}
                                                rounded
                                                color="#117183"
                                                type="submit"
                                                className="btn-block z-depth-1a"
                                                >
                                                    <MDBIcon icon="edit" className="mr-2" />
                                                    {allStrings.update}          
                                                </MDBBtn>
                                            }{this.state.actionType ==="VIEW"&&
                                                <MDBBtn onClick={()=>{this.deleteoccasion()}} rounded color="danger" className="btn-block z-depth-1a">
                                                    <MDBIcon icon="trash-alt" className="mr-2" />
                                                    {allStrings.remove}
                                                </MDBBtn>
                                            }
                                            </div>
                                        </form>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBContainer>
                            </CardContent>
                        </Card>
                    </div>
                </MDBCol> 
                {this.state.actionType==="VIEW"&&this.imageSection()}   
            </MDBRow>
            {this.state.actionType ==="VIEW"&&
            this.audiencesTable()
            }
      </MDBContainer>
      
    </div> 
  )
  }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  });
  
  const mapDispatchToProps = {
  };
  
  export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(occasionInfo)
  );